import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { MenuItem, Select, Button } from "@material-ui/core";
import "./Tableform.css";
import { getBookingById, getAdditionalBookingData, getQRCodeData, getSignature } from '../../../actions/GenomicsAction';
import { connect } from 'react-redux';
import { savePDF } from '@progress/kendo-react-pdf';
import { useRef } from 'react';
const useStyles = makeStyles({
  table: {
    height: "40px"
  },
  left: {
    margin: 600,
    width: "50%"
  },
  fontsize13: {
    fontSize: "13px",
  },
  rightContentHeader: {
    width: "88%",
    float: "left",
    textAlign: "left",
    paddingRight: "20px",
  },
  style: {
    background: "#AD70A6",
    color: "#fff",
    padding: 10,
    marginLeft: 5,
  }

});
interface Props {
  match: any;
  booking: any;
  getBookingById: any;
  getAdditionalBookingData: any;
  additionMember: any;
  getQRCodeData: any;
  qrcode: any;
  getSignature: any;
  signature: any;
  loading: Boolean;
}
const PhlebognadminViewBooking: React.FC<Props> = ({
  match,
  booking,
  getBookingById,
  getAdditionalBookingData,
  additionMember,
  getQRCodeData,
  qrcode,
  getSignature,
  signature,
  loading
}) => {

  const bookingId = match.params.id
  useEffect(() => {
    if (bookingId !== 0) {
      getBookingById(bookingId)
      getQRCodeData(bookingId)
      getSignature(bookingId)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bookingId])
  const classes = useStyles();
  const contentArea = useRef<any>(0)
  const pid = booking && booking?.customer_name + "-" + booking && booking?.pk;
  const [personName, setPersonName] = useState(bookingId)
  const handleExportWithFunction = () => {
    savePDF(contentArea.current, { paperSize: "A4", fileName: personName === bookingId ? booking.customer_name : additionMember.customer_name });
  }

  const spacimenType1 = ["[] Ambient", "[] Plasma: EDTA/CIT/ACD", "[] Blood Clot", "[] W.Blood ACD", "[] W.Blood EDTA", "[] W.Blood Fluoride", "[] W.Blood Heparin", "[] W.Blood Sodium Citrate]"]
  const spacimenType2 = ["[ ] Ambient", "[ ] FN Aspirate*", "[ ] Tissue-Large* ", "[ ] Tissue-Small* ", "[ ] Paraffin Block* ", "[ ] Smear", "[ ] Slide (H&E)", "[ ] Pus]"]
  const spacimenType3 = ["[ ] Ambient", "[ ] FN Aspirate*", "[ ] Tissue-Large* ", "[ ] Tissue-Small* ", "[ ] Paraffin Block* ", "[ ] Smear", "[ ] Slide (H&E)", "[ ] Pus]"]
  const essentialClinical = ["Provisional diagnosis :", "H/o Medication : Yes / No", "If Yes, Name :", "Status of Medication : Ongoing / Terminated", "If ongoing, Duration :", "If terminated, When :", " LMP (where applicable :", " Fasting Period :", "24 hour Urine Volume :", "For Histopathology / IHC, Attach Detailed History ", "Attach other relevant information :"
  ]
  useEffect(() => {
    if (personName !== 'none') {
      if (bookingId === personName) {
        getBookingById(`${bookingId}`);
      }
      else {
        getAdditionalBookingData(`${personName}`);
      }
    }
  }, [personName])

  const handleChange = (event: any) => {
    setPersonName(event.target.value);
  };

  return (
    <>
      <div id="tablemy">
        <div style={{ height: "20px", marginTop: "35%" }}>
          <h2></h2>
          <div className={classes.rightContentHeader}>
            <Select className="input"
              name="priority"
              variant="outlined"
              style={{ width: "50%", marginLeft: "1rem", marginBottom: "1rem", alignItems: "flex-start" }}
              value={personName}

              onChange={handleChange}
            >
              <MenuItem disabled selected value={'none'}>Customer Name</MenuItem>
              <MenuItem ></MenuItem>
              {/* {booking.additional_members &&
                booking.additional_members.length > 0 &&
                booking.additional_members.map((data: any) => {
                  return (
                    <MenuItem value={data?.id}>{data?.customer_name}</MenuItem>

                  )
                })} */}
            </Select>
            <Button
              variant="contained"
              style={{ marginLeft: "1rem", marginBottom: "1rem", background: "#AD70A6" }}
              onClick={handleExportWithFunction}
            >
              Print TRF
            </Button>
          </div>

        </div>
      </div>
      <div
        style={{
          width: 842,
          background: "#f1f1f1",
          margin: "20px auto",
          padding: 20
        }}
      >
        <div style={{ width: "100%", display: "flex", background: "#AD70A6", marginTop: "52px" }}>
          <div style={{ width: "50%", textAlign: "left", padding: 15 }}>
            <h3>Test Requisition Form (NIPS)</h3>
          </div>
          <div style={{ width: "50%", textAlign: "right", padding: 15 }}>
            <h1>Redcliffe</h1>
          </div>
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "flex-end",
            margin: "10px 0px",
            color: "#fff"
          }}
        >
          <div style={{ background: "#AD70A6", padding: 10 }}>Sample Id</div>
          <div
            style={{
              padding: "8px 5px",
              color: "#000",
              border: "2px solid #000"
            }}
          >
            RCL
          </div>
          <input></input>
        </div>
        <div
          style={{ width: "100%", background: "#AD70A6", textAlign: "center" }}
        >
          <h4 style={{ padding: 10 }}>PATIENT DETAILS</h4>
        </div>
        <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
          <div style={{ background: "#AD70A6", color: "#fff", padding: 10 }}>
            Name:
          </div>
          <input style={{ width: "40%", marginLeft: 5 }}></input>
          <div
            style={{
              background: "#AD70A6",
              color: "#fff",
              padding: 10,
              marginLeft: 5
            }}
          >
            Family Name:
          </div>
          <input style={{ width: "35%", marginLeft: 5 }}></input>
        </div>
        <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
          <div style={{ background: "#AD70A6", color: "#fff", paddingInline: "10px", height: "40px" }}>
            DOB
          </div>
          <input type="date" style={{ width: "35%", marginLeft: 5, height: "40px" }}></input>
          <div
            style={{
              background: "#AD70A6",
              color: "#fff",
              padding: 10,
              marginLeft: 5,
              height: "40px"
            }}
          >
            Ethnicity
          </div>
          <input style={{ width: "35%", marginLeft: 5, height: "40px" }}></input>
          <div
            style={{
              background: "#AD70A6",
              color: "#fff",
              padding: 10,
              marginLeft: 5
            }}
          >
            Consangunity
          </div>
          <div style={{ marginTop: 10, marginLeft: 10, width: "15%" }}>
            <input type="radio" id="Y" value="Y" />  <label >Y</label>
            <input type="radio" id="N" value="N" />  <label >N</label>
          </div>
        </div>
        <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
          <div style={{ background: "#AD70A6", color: "#fff", padding: 10 }}>
            Address
          </div>
          <input style={{ width: "100%", marginLeft: 5 }}></input>
        </div>
        <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
          <div style={{ background: "#AD70A6", color: "#fff", padding: 10 }}>
            city
          </div>
          <input style={{ width: "40%", marginLeft: 5 }}></input>
          <div
            style={{
              background: "#AD70A6",
              color: "#fff",
              padding: 10,
              marginLeft: 5
            }}
          >
            State
          </div>
          <input style={{ width: "40%", marginLeft: 5 }}></input>
          <div
            style={{
              background: "#AD70A6",
              color: "#fff",
              padding: 10,
              marginLeft: 5
            }}
          >
            Pincode
          </div>
          <input style={{ width: "40%", marginLeft: 5 }}></input>
        </div>
        <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
          <div style={{ background: "#AD70A6", color: "#fff", padding: 10 }}>
            PhoneNo.
          </div>
          <input type="number" style={{ width: "40%", marginLeft: 5 }}></input>
          <div
            style={{
              background: "#AD70A6",
              color: "#fff",
              padding: 10,
              marginLeft: 5
            }}
          >
            Email
          </div>
          <input type="email" style={{ width: "60%", marginLeft: 5 }}></input>

        </div>
        <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
          <div style={{ background: "#AD70A6", color: "#fff", padding: 10 }}>
            Condition/Habit:
          </div>
          <input style={{ width: "100%", marginLeft: 5 }}></input>
        </div>
        <div
          style={{ width: "100%", background: "#AD70A6", textAlign: "center" }}
        >
          <h4 style={{ padding: 10 }}>CLINICAL INDICATIONS</h4>
        </div>
        <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
          <div style={{ background: "#AD70A6", color: "#fff", padding: 10 }}>
            Weight(kg):
          </div>
          <input style={{ width: "35%", marginLeft: 5 }}></input>
          <div
            style={{
              background: "#AD70A6",
              color: "#fff",
              padding: 10,
              marginLeft: 5
            }}
          >
            Heiht(cms):
          </div>
          <input style={{ width: "35%", marginLeft: 5 }}></input>
          <div
            style={{
              background: "#AD70A6",
              color: "#fff",
              padding: 10,
              marginLeft: 5
            }}
          >
            LMP:
          </div>
          <input style={{ width: "35%", marginLeft: 5 }}></input>
        </div>
        <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
          <div
            style={{
              background: "#AD70A6",
              color: "#fff",
              padding: 10,
              marginLeft: 0
            }}
          >
            Mode of Conception:
          </div>
          <input style={{ width: "15%", marginLeft: 5 }}></input>
          <div style={{ marginTop: 10, marginLeft: 5, width: "15%" }}>
          </div>
        </div>
        <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
          <div style={{ background: "#AD70A6", color: "#fff", padding: 2, height: "50px" }}>
            Pregnancy info:
          </div>
          <input style={{ width: "100%", marginLeft: 5, height: "50px" }}></input>
          <div style={{ background: "#AD70A6", color: "#fff", padding: 2, height: "50px" }}>
            Gestational Age:
          </div>
          <input style={{ width: "100%", marginLeft: 5, height: "50px" }}></input>
        </div>
        <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
          <div style={{ background: "#AD70A6", color: "#fff", padding: 10 }}>
            Parity
          </div>
          <input style={{ width: "40%", marginLeft: 5 }}></input>
          <div
            style={{
              background: "#AD70A6",
              color: "#fff",
              padding: 10,
              marginLeft: 5
            }}
          >
            Gravida
          </div>
          <input style={{ width: "40%", marginLeft: 5 }}></input>
          <div
            style={{
              background: "#AD70A6",
              color: "#fff",
              padding: 10,
              marginLeft: 5
            }}
          >
            Para
          </div>
          <input style={{ width: "40%", marginLeft: 5 }}></input>
          <div
            style={{
              background: "#AD70A6",
              color: "#fff",
              padding: 10,
              marginLeft: 5
            }}
          >
            Abortion
          </div>
          <input style={{ width: "40%", marginLeft: 5 }}></input>
          <div
            style={{
              background: "#AD70A6",
              color: "#fff",
              padding: 10,
              marginLeft: 5
            }}
          >
            live
          </div>
          <input style={{ width: "40%", marginLeft: 5 }}></input>
        </div>
        <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
          <div style={{ background: "#AD70A6", color: "#fff", padding: 10 }}>
            Surrogate Mother (SM):
          </div>
          <input type="number" style={{ width: "27.6%", marginLeft: 5 }}></input>
          <div
            style={{
              background: "#AD70A6",
              color: "#fff",
              padding: 10,
              marginLeft: 5
            }}
          >
            SM Age:
          </div>
          <input type="email" style={{ width: "40%", marginLeft: 5 }}></input>
        </div>
        <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
          <div
            style={{
              background: "#AD70A6",
              color: "#fff",
              padding: 10,
            }}
          >
            Embryo Transfer Date:
          </div>
          <input type="email" style={{ width: "78%", marginLeft: 5 }}></input>
        </div>
        <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
          <div style={{ background: "#AD70A6", color: "#fff", padding: 10 }}>
            Specific Chromosomal Abnormalities of Fetus(If Known):
          </div>
          <input type="number" style={{ width: "50%", marginLeft: 5 }}></input>
        </div>
        <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
          <div style={{ background: "#AD70A6", color: "#fff", padding: 10 }}>
            Family History of Chromosomal Abnormality(If Any):
          </div>
          <input type="number" style={{ width: "55%", marginLeft: 5 }}></input>
        </div>
        <div
          style={{ width: "100%", background: "#AD70A6", textAlign: "center" }}
        >
          <h4 style={{ padding: 10 }}>TEST REQUIRED</h4>
        </div>
        <div style={{ width: "100%", display: "flex", margin: "10px 0px", height: "50px" }}>
          <div style={{ background: "#AD70A6", color: "#fff", padding: 10 }}>
            CRYSTA NIPS(Trisomy 21,18,13)
          </div>
          <input style={{ width: "40%", marginLeft: 5, height: "50px" }}></input>
          <div style={{ background: "#AD70A6", color: "#fff", padding: 10, height: "50px" }}>
            CRYSTA PLUS(Microdeletions)
          </div>
          <input style={{ width: "40%", marginLeft: 5, height: "50px" }}></input>
        </div>
        <div
          style={{ width: "100%", background: "#AD70A6", textAlign: "center" }}
        >
          <h4 style={{ padding: 10 }}>SAMPLE INFORMATION</h4>
        </div>
        <div>
          <div style={{ width: "100%", display: "flex", margin: "10px 0px", height: "50px" }}>
            <div style={{ background: "#AD70A6", color: "#fff", padding: 10, height: "50px" }}>
              Date of Collection
            </div>
            <input type="date" style={{ width: "35%", marginLeft: 5, height: "50px" }}></input>
            <div style={{ background: "#AD70A6", color: "#fff", padding: 10, height: "50px" }}>
              Time of Collection
            </div>
            <input style={{ width: "35%", marginLeft: 5, height: "50px" }}></input>
          </div>
          <div
            style={{ width: "100%", background: "#AD70A6", textAlign: "center" }}
          >
            <h4 style={{ padding: 10 }}>CLINICIAN DETAILS</h4>
          </div>

        </div>
        <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
          <div style={{ background: "#AD70A6", color: "#fff", padding: 10 }}>
            Clinician Name:
          </div>
          <input style={{ width: "80%", marginLeft: 5 }}></input>
        </div>
        <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
          <div style={{ background: "#AD70A6", color: "#fff", padding: 10 }}>
            PhoneNo.
          </div>
          <input type="number" style={{ width: "40%", marginLeft: 5 }}></input>
          <div
            style={{
              background: "#AD70A6",
              color: "#fff",
              padding: 10,
              marginLeft: 5
            }}
          >
            Email
          </div>
          <input type="email" style={{ width: "60%", marginLeft: 5 }}></input>
        </div>
        <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
          <div style={{ background: "#AD70A6", color: "#fff", padding: 10 }}>
            Hospital
          </div>
          <input style={{ width: "40%", marginLeft: 5 }}></input>
          <div
            style={{
              background: "#AD70A6",
              color: "#fff",
              padding: 10,
              marginLeft: 5
            }}
          >
            Hospital
          </div>
          <input style={{ width: "40%", marginLeft: 5 }}></input>
        </div>

        <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
          <div style={{ background: "#AD70A6", color: "#fff", padding: 10 }}>
            city
          </div>
          <input style={{ width: "40%", marginLeft: 5 }}></input>
          <div
            style={{
              background: "#AD70A6",
              color: "#fff",
              padding: 10,
              marginLeft: 5
            }}
          >
            State
          </div>
          <input style={{ width: "40%", marginLeft: 5 }}></input>
          <div
            style={{
              background: "#AD70A6",
              color: "#fff",
              padding: 10,
              marginLeft: 5
            }}
          >
            Pincode
          </div>
          <input style={{ width: "40%", marginLeft: 5 }}></input>
        </div>
        <div
          style={{
            width: "100%",
            margin: "10px 0px",
            border: "1px solid",
            height: "90px"
          }}
        >
          <div style={{ padding: 10, width: "100%" }}>
            <b>Clinician statement: I attest that this patient has been informed about details of the test,
              its capabilities and Limitations,and has given consent for this test.</b>
          </div>
          <div style={{ width: "100%", display: "flex" }}>
            <div style={{ padding: 10, textAlign: "left", width: "50%" }}>
              Date:
            </div>
            <div style={{ padding: 10, textAlign: "right", width: "50%" }}>
              Clinician's Signature:
            </div>
            <div style={{ padding: 10, textAlign: "right", width: "50%" }}>
              For Lab Personnel (Signature):
            </div>
          </div>
        </div>
        <div
          style={{
            width: "100%",
            background: "#1289A7",
            textAlign: "center",
            color: "#fff"
          }}
        >
        </div>
        <div
          style={{ width: "100%", background: "#AD70A6", textAlign: "center" }}
        >
          <h4 style={{ padding: 10 }}>TERMS & CONDITIONS</h4>
        </div>
        <div
          style={{
            width: "100%",
            margin: "10px 0px",
            display: "flex"
          }}
        >
          <div style={{ padding: 10, width: "50%", textAlign: "left" }}>
            <b style={{ fontSize: "14px" }}>DELIVERY OF SERVICES</b>
            <p style={{ textAlign: "justify", fontSize: "14px" }}>
              Subject to receipt of the Fees, Redcliffe Lab ("Redcliffe") shall
              carry out the test(s) as requested in this Test Requisition Form
              ("Test(s)") in conformity with the applicable industry standards.
            </p>
            <b style={{ fontSize: "14px" }}>REPORTS</b>
            <p style={{ textAlign: "justify", fontSize: "14px" }}>
              The Report shall be generated within such Turn-Around-Time ("TAT")
              as mentioned in this Test Requisition Form(s). However, such TAT
              may vary depending upon the complexity of Test(s) requested.
              Redcliffe shall under no circumstances be liable for any delay
              beyond the aforementioned TAT. It is hereby clarified that the
              Report(s) generated from the Test(s) do not provide any diagnosis
              or opinion or recommends any cure in any manner. Redcliffe hereby
              recommends the Patient and/or the guardians of the Patients to
              take assistance of the Clinician or a certified physician or
              doctor, to interpret the Report(s) thus generated. Redcliffe
              hereby disclaims all liability arising in connection with the
              Report(s).
            </p>
            <b style={{ fontSize: "14px" }}>TERM</b>
            <p style={{ textAlign: "justify", fontSize: "14px" }}>
              This Terms & Conditions shall become effective from the date of
              signing of this Test Requisition Form and shall remain valid,
              effective and binding till delivery of the Report.
            </p>
            <b style={{ fontSize: "14px" }}>TERMINATION</b>
            <p style={{ textAlign: "justify", fontSize: "14px" }}>
              It is agreed that if the Test(s) requested in this Test
              Requisition Form is terminated for any reason whatsoever,
              Redcliffe shall not be required to refund the Fees paid in advance
              by the Patient and/or the guardians of the Patients for the
              Test(s). However, refund shall be awarded if and only if the
              sample provided doesn't pass the QC or if the sample provided is
              inadequate for performing the test.
            </p>
            <b style={{ fontSize: "14px" }}> LIMITATION OF LIABILITY</b>
            <p style={{ textAlign: "justify", fontSize: "14px" }}>
              In addition to any disclaimer of liability provided by Redcliffe
              elsewhere in this test Requisition Form, Redcliffe further
              disclaims any and all liability arising out of any claim,
              liability, demand, compensation, loss, damage, judgment or other
              obligation or right of action which is suffered by the Clinician
              and/or the Patient and/or the guardians of the Patients or any
              third party whether directly or indirectly for relying on the
              Report(s) and/or in relation to the Test(s) availed under this
              Test Requisition Form(s).
            </p>
          </div>
          <div style={{ padding: 10, width: "50%", textAlign: "left" }}>


            <b style={{ fontSize: "14px" }}>
              GOVERNING LAW, JURISDICTION AND DISPUTE RESOLUTION
            </b>
            <p style={{ textAlign: "justify", fontSize: "14px" }}>
              These Terms and Conditions and this Test Requisition Form shall be
              governed by and construed in accordance with Indian law and the
              courts in Gurgaon Haryana shall have exclusive injunctive
              jurisdiction. In the event of any dispute, controversy or claim
              whatsoever arising from these Terms and Conditions and/ or this
              Test Requisition Form, the parties shall undertake to make every
              effort to reach an amicable settlement within fifteen (15) days
              upon reference of the dispute by any party through discussions
              among the concerned representatives of parties, failing which the
              dispute, controversy or claim shall be settled by Arbitration by a
              Sole Arbitrator appointed by the Gurgaon Court, Gurgaon, Haryana
              as per Indian Arbitration and Conciliation Act, 1996 as amended
              from time to time. The venue of arbitration shall be Gurgaon and
              it shall be conducted in English language. The award passed by the
              Sole Arbitrator shall be final and binding upon the parties.
            </p>
            <b style={{ fontSize: "14px" }}>NOTICE</b>
            <p style={{ textAlign: "justify", fontSize: "14px" }}>
              All notices, statements or other communication required or
              permitted to be given or made shall be in writing and in English
              language. Such notices will deliver by hand or sent by prepaid
              post with recorded delivery, or facsimile transmission addressed
              to the intended recipient at the address mentioned in this Test
              Requisition Form.
            </p>
            <b style={{ fontSize: "14px" }}>INDEPENDENT PARTIES </b>
            <p style={{ textAlign: "justify", fontSize: "14px" }}>
              All parties effected hereunder are independent entities and
              neither of the parties are an agent, employee or joint venture of
              the other and they shall not represent themselves as such to any
              third parties.
            </p>
          </div>
        </div>
        <div
          style={{ width: "100%", background: "#AD70A6", textAlign: "center" }}
        >
          <h3 style={{ padding: 10 }}>DECLARATION</h3>
        </div>
        <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
          <p style={{ textAlign: "justify", fontSize: "14px", background: "#dc8cf5" }}>
            I/We have read and understood the terms and conditions mentioned above unconditionally accept them as binding on me/us. I/ We
            hereby undertake to pay all the charges raised on account of services availed. it is agreed that the data can be re-analysed or used
            by the company for research purpose. I/We fruther declare and undertake that the above information provided by me/us is true and
            correct in all aspects.
          </p>
        </div>
        <div style={{ width: "100%", display: "flex" }}>
            <div style={{ padding: 10, textAlign: "left", width: "50%" }}>
              Sign. of Expetant Mother*:
            </div>
            <div style={{ padding: 10, textAlign: "right", width: "50%" }}>
              Date:
            </div>
            <div style={{ padding: 10, textAlign: "right", width: "50%" }}>
               Place:
            </div>
          </div>
        <div
          style={{
            width: "100%",
            background: "#AD70A6",
            color: "#fff",
            textAlign: "center",
            padding: 10
          }}
        >
          <h3>Redcliffe Life Tech Pvt.Ltd.</h3>
          <h6>
            H-55, Sector-63, Electronic City Noida, Noida-201301 (U.P) INDIA,
            Phone: 898 898 1777
            <br /> www.redcliffelabs.com
          </h6>
        </div>
      </div>
    </>
  );
}
const mapStateToProps = (state: any) => ({
  booking: state.GenomicsCustomerExecutiveReducer.booking,
  additionMember: state.GenomicsCustomerExecutiveReducer.additionMember,
  qrcode: state.GenomicsCustomerExecutiveReducer.qrcode,
  signature: state.GenomicsCustomerExecutiveReducer.signature,
  loading: state.GenomicsCustomerExecutiveReducer.loading,
})

export default connect(mapStateToProps, {
  getBookingById,
  getAdditionalBookingData,
  getQRCodeData,
  getSignature,
})(PhlebognadminViewBooking);
